import { Skeleton } from "@aurem/ui";

export const NotificationListSkeleton = () => (
  <div className="flex flex-col p-3">
    {Array.from({ length: 2 }).map((_, i) => (
      <div key={i} className="flex gap-3 bg-white py-5 ps-4 pe-5">
        <Skeleton className="h-10 w-10 shrink-0 rounded-xl" />
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
    ))}
  </div>
);
